export const ADD_CONTACT = "ADD_CONTACT";
export const FETCH_CONTACTS = "FETCH_CONTACTS";
export const FETCH_POSTS = "FETCH_POSTS";
export const FETCH_USER = "FETCH_USER";
export const FETCH_THEME = "FETCH_THEME";
export const FETCH_LANGUAGE = "FETCH_LANGUAGE";
export const FETCH_TOPIC = "FETCH_TOPIC";
export const FETCH_USERS = "FETCH_USERS";
export const UPDATE_STATE = "UPDATE_STATE";
export const SET_POSTS = "SET_POSTS";
export const SET_USER = "SET_USER";
export const ADD_LIKE = "ADD_LIKE";
export const REMOVE_LIKE = "REMOVE_LIKE";
export const ADD_COMMENT = "ADD_COMMENT";

